import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import roles from "./slices/rolesSlice";
import users from "./slices/usersSlice";
import branchLookups from "./slices/branchLookupSlice";
import agencies from "./slices/AgenciesSlice";
import testDirectories from "./slices/testDirectorySlice";
import panels from "./slices/panelSlice";
import newOrder from "./slices/newOrderSlice";
import insurances from "./slices/InsuranceSlice";
import departments from "./slices/departmentsSlice";
import orders from "./slices/orderStatusSlice";
import lab from "./slices/labSlice";
import srd from "./slices/srdSlice";
import phlebotomy from "./slices/phlebotomySlice";
import results from "./slices/resultSlice";
import dss from "./slices/dssSlice";
import search from "./slices/searchSlice";
import dashboard from "./slices/dashboardSlice";
import tat from "./slices/tatSlice";
import report from "./slices/reportSlice";
import auditLog from "./slices/AuditLogSlice";
import customerSatsfactionAndComplainingSlice from "./slices/QandASlice";
import agencyPayments from "./slices/agencyPaymentsSlice"; // Add this import


const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    roles,
    users,
    departments,
    agencies,
    branchLookups,
    testDirectories,
    panels,
    newOrder,
    orders,
    lab,
    srd,
    phlebotomy,
    insurances,
    results,
    dss,
    search,
    dashboard,
    tat,
    report,
    auditLog,
    customerSatsfactionAndComplainingSlice,
    agencyPayments, 
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
